var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecomndquestionAsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08333 0.625C7.08333 0.279825 6.8035 0 6.45833 0C6.11317 0 5.83333 0.279825 5.83333 0.625V5.83333H0.625C0.279825 5.83333 0 6.11317 0 6.45833C0 6.8035 0.279825 7.08333 0.625 7.08333H5.83333V12.2917C5.83333 12.6368 6.11317 12.9167 6.45833 12.9167C6.8035 12.9167 7.08333 12.6368 7.08333 12.2917V7.08333H12.2917C12.6368 7.08333 12.9167 6.8035 12.9167 6.45833C12.9167 6.11317 12.6368 5.83333 12.2917 5.83333H7.08333V0.625Z",
    fill: "#004070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecomndquestionAsk);
export default __webpack_public_path__ + "static/media/recomndquestion-ask.dbf08b35bbaffdafa319350714a0a175.svg";
export { ForwardRef as ReactComponent };